const getTransitionStyles = timeout => {
  return {
    entering: {
      opacity: 0,
      transform: `translateY(9999px)`
    },
    entered: {
      transition: `opacity ${timeout *
        2}ms cubic-bezier(0.23, 1, 0.32, 1), transform ${timeout *
        2}ms cubic-bezier(0.23, 1, 0.32, 1)`,
      opacity: 1,
      transform: `translateY(0)`
    },
    exiting: {
      transition: `opacity ${timeout}ms cubic-bezier(0.23, 1, 0.32, 1), transform ${timeout}ms cubic-bezier(0.23, 1, 0.32, 1)`,
      opacity: 0,
      transform: `translateY(96px)`
    }
  };
};

const getTransitionStyle = ({ timeout, status }) =>
  getTransitionStyles(timeout)[status];

export default getTransitionStyle;



// WEBPACK FOOTER //
// ./src/utils/getTransitionStyle.js